import React, { Component } from 'react'
import InputParent from './InputParent';
import axios from 'axios'
import { isset, makeId } from '../../helpers/default';

/**
 * props
 * - Direct: true/false
 * - DecoratorIn : (value, this) => {}
 * - DecoratorOut : (value, this) => {}
 * - OnChange : (value, this) => {}
 * - Suggest : an URL
 * - DefaultValue : default value
 * - Options: an array [{key:..., value:...}]
 * - OnChangeBlur: (value, this)=>{} Onchange and value is modified
 * - ShowAllList : true/false show all datalist
 */

class InputPassword extends InputParent {

	constructor(props) {
		super(props);

		this.state['show'] = false

	}


	render() {

		this.initial({ style: 1, className: 1, type:1 });
		var val = this.showValue()
		return (
			<div style={{ display: 'flex', padding: 0, margin: 0, width: '100%', position: 'relative' }}>
				<input
					className={this.props.className + " " + (val !== '' ? "filled" : "empty")}
					style={{ ...(this.style ?? {}), 'width': '100%', paddingRight: 30 }}
					value={val}
					onChange={(event) => { this.onChangeHandle(event) }}
					onBlur={event => this.onBlurHandle(event)}
					ref={input => this.input = input}
					type={this.state.show ? 'text' : 'password'}
					{...this.rent}
				/>

				{this.state.show 
				? <i style={{position:'absolute', right:5, top:"calc(50% - 6px)", fontSize:12, color:'gray', cursor:'pointer'}} className='fa fa-eye-slash' onClick={()=>this.setState({show: false})}></i>
				: <i style={{position:'absolute', right:5, top:"calc(50% - 6px)", fontSize:12, color:'gray', cursor:'pointer'}} className='fa fa-eye' onClick={()=>this.setState({show: true})}></i>
				}
				
			</div>
		)
	}
}

export default InputPassword;